import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useEventDateInformation} from '../../../../../../../commons/hooks/dates'
import {classes} from './event-info.st.css'
import {EventInfoProps} from './index'

export const EventInfo = ({title, location, eventId}: EventInfoProps) => {
  const {isMobile} = useEnvironment()
  const {fullDate} = useEventDateInformation(eventId)

  return (
    <div className={classNames(classes.container, {[classes.desktopContainer]: !isMobile})}>
      <Text tagName="h1" className={classNames(isMobile ? classes.mobileName : classes.name)} data-hook={DH.EVENT_INFO}>
        {title}
      </Text>
      <Text tagName="p" className={classes.dateLocation}>
        {fullDate}
      </Text>
      <Text tagName="p" className={classes.dateLocation}>
        {location}
      </Text>
    </div>
  )
}
